export const ORDER_STATUSES = {
  APPROVED: 'approved',
  BOOKED: 'booked',
  CANCELED: 'canceled',
  COOLING: 'cooling',
  CONFIRMED: 'confirmed',
  CREATED: 'created',
  DEPOSIT: 'deposit',
  DOCUMENTS_SENT: 'documents_sent',
  FLIGHT_CONFIRMED: 'flight_confirmed',
  GOT_BACK: 'got_back',
  HOTEL_CONFIRMED: 'hotel_confirmed',
  NOT_CONFIRMED: 'not_confirmed',
  ON_TRIP: 'on_trip',
  PAID: 'paid',
  SURVEY_COMPLETED: 'survey_completed',
  ANNULLED: 'annulled',
};

export const TITLES = {
  [ORDER_STATUSES.APPROVED]: 'начат',
  [ORDER_STATUSES.BOOKED]: 'бронь оформ.',
  [ORDER_STATUSES.CANCELED]: 'отменен',
  [ORDER_STATUSES.COOLING]: 'охлаждение',
  [ORDER_STATUSES.CONFIRMED]: 'подтвержден',
  [ORDER_STATUSES.DEPOSIT]: 'депозит',
  [ORDER_STATUSES.DOCUMENTS_SENT]: 'док. высл.',
  [ORDER_STATUSES.FLIGHT_CONFIRMED]: 'рейс ОК',
  [ORDER_STATUSES.GOT_BACK]: 'прилетел',
  [ORDER_STATUSES.HOTEL_CONFIRMED]: 'отель ОК',
  [ORDER_STATUSES.NOT_CONFIRMED]: 'отказ ТО',
  [ORDER_STATUSES.ON_TRIP]: 'отдыхает',
  [ORDER_STATUSES.CREATED]: 'новый',
  [ORDER_STATUSES.PAID]: 'оплачен',
  [ORDER_STATUSES.SURVEY_COMPLETED]: 'опрошен',
  [ORDER_STATUSES.ANNULLED]: 'аннулирован',
};
